export default {
    transactionsTitle: 'Transaksjoner',
    transactionDetailsTitle: 'Detaljer',
    transactionsIngress: 'Her kan du se dine siste bevegelser',
    transactionsEmpty: 'Ingen bevegelser å vise',
    transactionsMonthTitle: 'Bevegelser',
    transactionsDate: 'Bokført dato',
    transactionsAmount: 'Beløp',
    transactionsAccount: 'Kontonummer',
    transactionShowDetails: 'Vis mer',
    transactionsShowMore: 'Vis flere',
    transactionsDescription: 'Beskrivelse',
    transactionsOriginalValuta: 'Opprinnelig valuta',
    transactionsOriginalAmount: 'Opprinnelig beløp',
    transactionsTransferredValuta: 'Overført valuta',
    transactionsAcceptedValuta: 'Akseptert valuta',
    transactionsReserved: 'Reservert',
    transactionsRegisteredDate: 'Kjøpsdato',
    transactionsError: 'Noe gikk galt under henting av transaksjoner. Prøv igjen senere',
    transactionDetailsError: 'Noe gikk galt under henting av detaljer. Prøv igjen senere',
    transactionDetailEmpty: 'Finner ikke flere detaljer',
    transactionDetailsEmpty: 'Fant ingen detaljer for denne transaksjonen.',
    transactionDetailsItem_postingSpecification: 'Transaksjonsdetaljer',
    transactionEmptyText: 'Her har det ikke skjedd så mye!',
    transactionNoMoreText: 'Det var alle transaksjonene på denne kontoen.',
    transactionSeeMore: 'Se flere transaksjoner',
    transactionReceiver: 'Mottaker',
    transactionFrom: 'Fra',
    transactionTo: 'Til',
    transactionDateLabel: 'Dato',
    transactionBooked: 'Bokført',
    transactionNumber: 'Transaksjonsnummer',
    transactionKIDNumber: 'KID',
    transactionMessage: 'Beskjed',
    transactionCategory: 'Kategori',
    transactionReference: 'Referanse',
    transactionDetailsText: 'Detaljer',
    transactionAccountUrlPath: '/nettbank/kontoer/konto',
    transactionAccountUrlParamId: 'id',
    transactionYourCard: 'Administrer kortet ditt',
    transactionCategoryLabel_INTEREST: 'RENTE',
    transactionCategoryLabel_FEES: 'GEBYR',
    transactionCategoryLabel_CASH: 'BETALING',
    transactionCategoryLabel_PAYMENT: 'UTTAK',
    transactionCategoryLabel_PURCHASE: 'OVERFØRING',
    transactionCategoryLabel_CREDIT: 'KJØP',
    transactionCategoryLabel_DEBIT: 'KJØP',
    transactionCategoryLabel_INSURANCE: 'FORSIKRING',
    transactionCategoryLabel_BONUS: 'BONUS',
    transactionCategoryLabel_UNKNOWN: 'ANNET',
    transactionsFetchErrorMessage: 'Noe gikk galt ved innhenting av kortets transaksjonsliste.',
    cardFetchErrorMessage: 'Noe gikk galt ved innhenting av kortinformasjonen.',
    cardAccountFetchErrorMessage: 'Noe gikk galt ved innhenting av kontoinformasjonen.',
    transactionsCreditInfoUsed: 'Du har brukt',
    transactionsCreditInfoAvailable: 'Du har tilgode',
};
